const cssAnimationsIn = [
  'zoomIn',
  'fadeInDown',
  'fadeInLeft',
  'fadeInRight',
  'fadeInUp',
  'fadeInTopLeft',
  'fadeInTopRight',
  'fadeInBottomLeft',
  'fadeInBottomRight'
]

export function showFromLeft(sectionIndex) {
  const imageAnimation = randomAnimationFrom('left')
  const textAnimation = randomAnimationFrom('right')

  showInfoSection(sectionIndex, imageAnimation, textAnimation)
}

export function showFromRight(sectionIndex) {
  const imageAnimation = randomAnimationFrom('right')
  const textAnimation = randomAnimationFrom('left')

  showInfoSection(sectionIndex, imageAnimation, textAnimation)
}

export function showFromCenter(sectionIndex) {
  const imageAnimation = randomAnimationFrom('top')
  const textAnimation = randomAnimationFrom('bottom')

  showInfoSection(sectionIndex, imageAnimation, textAnimation)
}

export function hideInfoSection(sectionIndex) {
  const imageContainer = document.getElementById(`image-container-${sectionIndex - 1}`)
  const descriptionContainer = document.getElementById(`description-container-${sectionIndex - 1}`)
  const buttonsContainer = document.getElementById(`btns-container-${sectionIndex - 1}`)

  Promise.all([
    animateCSS(imageContainer, 'zoomOut'),
    animateCSS(descriptionContainer, 'zoomOut')
  ])
    .then(() => {
      buttonsContainer?.classList?.add('container-hidden')
      imageContainer.classList.add('hidden')
      descriptionContainer.classList.add('hidden')
    })
}

function showInfoSection(sectionIndex, imageAnimation, textAnimation) {
  const imageContainer = document.getElementById(`image-container-${sectionIndex - 1}`)
  const descriptionContainer = document.getElementById(`description-container-${sectionIndex - 1}`)
  const buttonsContainer = document.getElementById(`btns-container-${sectionIndex - 1}`)

  imageContainer.classList.remove('hidden')
  descriptionContainer.classList.remove('hidden')

  Promise.all([
    animateCSS(imageContainer, imageAnimation),
    animateCSS(descriptionContainer, textAnimation)
  ])
    .then(() => {
      buttonsContainer?.classList?.remove('container-hidden')
    })
}

async function animateCSS (element, animation) {
  return new Promise(resolve => {
    element.classList.add('animate__animated', `animate__${animation}`)

    function handleAnimationEnd(event) {
      event.stopPropagation()
      element.classList.remove('animate__animated', `animate__${animation}`)

      resolve('Animation ended')
    }

    element.addEventListener('animationend', handleAnimationEnd, { once: true })
  })
}


function randomAnimationFrom(from) {
  const animations = cssAnimationsIn.filter(anim => anim === 'zoomIn' || anim.toLowerCase().includes(from))
  return animations[Math.floor(Math.random() * animations.length)]
}